export default __webpack_public_path__ + "static/media/file_00001 (5).3b3e6b52.pdf";